<template>
  <div>
    <transition
      enter-active-class="animated slideInLeft"
      leave-active-class="animated slideOutLeft"
      :duration="300"
      mode="out-in"
    >
      <div v-if="!$root.editMode">
        <el-row
          style="
            text-align: center;
            font-size: 16px;
            color: #303133;
            line-height: 18px;
            cursor: pointer;
            padding-top: 10px;
            padding-bottom: 5px;
          ">
        <span @click="ShowDetail"
            >フィルタリング条件
            <i v-if="barShowFlg" class="el-icon-arrow-up"></i>
            <i v-else class="el-icon-arrow-down"></i>
          </span>
        </el-row>
        <div v-if="barShowFlg">
          <el-row>
            <el-col :span="12" :lg="6" style="margin-left: 15px; margin-top: 5px">
              <span style="padding-right: 20px;">{{ this.$root.htmlConst.cons_246_compare_date }}</span>
              <el-date-picker style="width: 45%"
                  align="right"
                  v-model="datePicker"
                  type="date"
                  format="yyyy/MM/dd"
                  value-format="yyyy-MM-dd"
                  :clearable="false"
                >
              </el-date-picker>
            </el-col>

            <el-col :span="12" :lg="6">
              <span>{{ this.$root.htmlConst.cons_246_group }}</span>
              <el-select v-model="selected_group" style="width: 45%">
                <el-option
                  v-for="item in group_list"
                  :key="item.key"
                  :label="item.value"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-col>

            <el-col :span="12" :lg="6"
              ><span>{{ this.$root.htmlConst.cons_246_response_type }}</span>
              <el-select v-model="selected_response_type" style="width: 45%">
                <el-option
                  v-for="item in response_type_list"
                  :key="item.key"
                  :label="item.value"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-col>

            <el-col :span="12" :lg="5" 
              ><span>{{ this.$root.htmlConst.cons_246_only_service_time }}</span>
              <el-checkbox style="margin-left: 15px;" v-model="checkedServiceTime"></el-checkbox>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" :lg="2">
              <el-button
                style="height: 20px; width: 75px; margin-left: 14px"
                class="select"
                type="success"
                @click="toggleView"
                >{{ $root.htmlConst.cons_236_search_button_display }}</el-button
              >
            </el-col>
            <el-col :span="12" :lg="2">
              <el-button
                style="height: 20px; width: 75px; margin-left: -10px"
                class="select"
                type="primary"
                @click="clearClick"
                >{{ $root.htmlConst.cons_237_clear_button_display }}</el-button
              >
            </el-col>
          </el-row>
        </div>
      </div>
    </transition>
    <div v-loading="loading">
        <el-row>
          <div>
            <img src="../assets/forecast.png" style="position: absolute;left: 521px;top: 40px;z-index:1;" />
          </div>
          <div>
            <img src="../assets/actual.png" style="position: absolute;left: 652px;top: 38px;z-index:1;" />
          </div>
          <div style="position: absolute;left: 126px;top: 14px;z-index:1;width: 1118px;height: 25px;background-color: #00B2F3;">
            <span style="font-weight: bold;color: white;padding-left: 10px;">{{ nowDisplayTitle }}</span>
          </div>
          <div style="position: absolute;width:3px;height:56.7%;
          background-image:linear-gradient(rgb(255,236,193) 0%, rgb(255,236,193) 80%, transparent 50%);
          background-size:100% 18px;background-repeat:repeat-y;top:75px;z-index:1;" :style="{left: leftpx}"></div>
          <echarts
            :auto-resize="true"
            class="chart-view-picmap"
            :option="optionNow"
          />
        </el-row>
        <el-row>
          <div>
            <img src="../assets/forecast.png" style="position: absolute;left: 521px;top: 40px;z-index:1;" />
          </div>
          <div>
            <img src="../assets/actual.png" style="position: absolute;left: 652px;top: 38px;z-index:1;" />
          </div>
          <div style="position: absolute;left: 126px;top: 14px;z-index:1;width: 1118px;height: 25px;background-color: #00B2F3;">
            <span style="font-weight: bold;color: white;padding-left: 10px;">{{ selectedDisplayTitle }}</span>
          </div>
          <div style="position: absolute;width:3px;height:56.7%;
          background-image:linear-gradient(rgb(255,236,193) 0%, rgb(255,236,193) 80%, transparent 50%);
          background-size:100% 18px;background-repeat:repeat-y;top:75px;z-index:1;" :style="{left: leftpx}"></div>
          <echarts
            :auto-resize="true"
            class="chart-view-picmap"
            :option="optionSelected"
          />
        </el-row>
    </div>
  </div>
</template>

<script>
import api from "@/api";
var moment = require("moment-timezone");
export default {
  name: "PicMapHeaderMenu",
  created() {
    this.datePicker = moment().format("YYYY-MM-DD");
    this.selected_group = this.group_list[1];
    this.selected_response_type = this.response_type_list[0];
    this.nowDisplayTitle = "今日のピークマップ・グループ" + this.selected_group.value;
    this.selectedDisplayTitle = this.datePicker + "のピークマップ・グループ" + this.selected_group.value;
    let nowHour = moment().hour();
    this.timeHour = nowHour;
    let leftpx = this.timeLineList[nowHour];
    this.leftpx = leftpx + 'px';
    api.getHtmlConst().then(
      (res) => {
        if (res && res.data) {
          let data = res.data;
          this.$root.htmlConst = data.htmlConst;
        }
      },
      (err) => {
        console.log(err);
      }
    );
    let selectedType;
    if (this.selected_response_type.value == "電話応対") {
      selectedType = "tel";
    } else if (this.selected_response_type.value == "チャット応対") {
      selectedType = "chat";
    }
    let selectedGroup;
    if (this.selected_group.value == "01000") {
      selectedGroup = "01";
    } else if (this.selected_group.value == "02000") {
      selectedGroup = "02";
    }
    let self = this;
    self.loading = true;
    api.getPicMapCount(this.datePicker, selectedGroup, selectedType, this.checkedServiceTime).then(
      (res) => {
        let data = res.data;
        let nowDate = data.output_list['now'];
        let lastYearDate = data.output_list['lastYear'];
        let newData = nowDate.concat(lastYearDate);
        let selectedDate = data.output_list['selected'];
        let selectedLastYearDate = data.output_list['selectedLastYear'];
        let newSelectedData = selectedDate.concat(selectedLastYearDate);
        
        self.optionNow = {
          baseOption: {
            title: {
              right: "10%",
            },
            tooltip: {
              formatter: function (params) {
                  return params.seriesName + "<br />"+ params.marker + params.name +"時 : " + params.value;
              },
            },
            calculable: true,
            barMaxWidth: "50%",
            grid: {
              top: 80,
              bottom: 80,
            },
            xAxis: [
              {
                type: "category",
                name: "時",
                data: data.hour_list,
                splitLine: {
                  show: false,
                },
              },
            ],
            yAxis: [
              {
                type: "value",
                name: "件",
              },
            ],
            series: newData,
            // series: [{
            //       name: '2022-09-15',
            //       type: 'bar',
            //       stack: '件',
            //       color: '#61a0a8',
            //       data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 0]
            //   }, {
            //       name: '2022-09-15時間帯外',
            //       type: 'bar',
            //       stack: '件',
            //       color: '##B3B3B3',
            //       data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 0]
            //   },{
            //       name: '2022-09-15',
            //       type: 'bar',
            //       stack: '件',
            //       color: '#d48265',
            //       data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 0]
            //   },]
          },
        };

        self.optionSelected = {
          baseOption: {
            title: {
              right: "10%",
            },
            tooltip: {
              formatter: function (params) {
                  return params.seriesName + "<br />"+ params.marker + params.name +"時 : " + params.value;
              },
            },
            calculable: true,
            barMaxWidth: "50%",
            grid: {
              top: 80,
              bottom: 80,
            },
            xAxis: [
              {
                type: "category",
                name: "時",
                data: data.hour_list,
                splitLine: {
                  show: false,
                },
              },
            ],
            yAxis: [
              {
                type: "value",
                name: "件",
              },
            ],
            series: newSelectedData
          },
        };
        self.loading = false;
      },
      (err) => {
        console.log(err);
      }
    );
  },
  mounted: function () {
    let self = this;
    this.timer = setInterval(function () {
      let nowTimeHour = moment().hour();
      if (nowTimeHour != self.timeHour) {
        self.loading = true;
        self.timeHour = nowTimeHour;
        let leftpx = self.timeLineList[nowTimeHour];
        self.leftpx = leftpx + 'px';
        let selectedType;
        if (self.selected_response_type.value == "電話応対") {
          selectedType = "tel";
        } else if (self.selected_response_type.value == "チャット応対") {
          selectedType = "chat";
        }
        let selectedGroup;
        if (self.selected_group.value == "01000") {
          selectedGroup = "01";
        } else if (self.selected_group.value == "02000") {
          selectedGroup = "02";
        }
        
        api.getPicMapCount(self.datePicker, selectedGroup, selectedType, self.checkedServiceTime).then(
          (res) => {
            let data = res.data;
            let nowDate = data.output_list['now'];
            let lastYearDate = data.output_list['lastYear'];
            let newData = nowDate.concat(lastYearDate);
            let selectedDate = data.output_list['selected'];
            let selectedLastYearDate = data.output_list['selectedLastYear'];
            let newSelectedData = selectedDate.concat(selectedLastYearDate);
            
            self.optionNow = {
              baseOption: {
                title: {
                  right: "10%",
                },
                tooltip: {
                  formatter: function (params) {
                      return params.seriesName + "<br />"+ params.marker + params.name +"時 : " + params.value;
                  },
                },
                calculable: true,
                barMaxWidth: "50%",
                grid: {
                  top: 80,
                  bottom: 80,
                },
                xAxis: [
                  {
                    type: "category",
                    name: "時",
                    data: data.hour_list,
                    splitLine: {
                      show: false,
                    },
                  },
                ],
                yAxis: [
                  {
                    type: "value",
                    name: "件",
                  },
                ],
                series: newData,
                // series: [{
                //       name: '2022-09-15',
                //       type: 'bar',
                //       stack: '件',
                //       color: '#61a0a8',
                //       data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 0]
                //   }, {
                //       name: '2022-09-15時間帯外',
                //       type: 'bar',
                //       stack: '件',
                //       color: '##B3B3B3',
                //       data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 0]
                //   },{
                //       name: '2022-09-15',
                //       type: 'bar',
                //       stack: '件',
                //       color: '#d48265',
                //       data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 0]
                //   },]
              },
            };

            self.optionSelected = {
              baseOption: {
                title: {
                  right: "10%",
                },
                tooltip: {
                  formatter: function (params) {
                      return params.seriesName + "<br />"+ params.marker + params.name +"時 : " + params.value;
                  },
                },
                calculable: true,
                barMaxWidth: "50%",
                grid: {
                  top: 80,
                  bottom: 80,
                },
                xAxis: [
                  {
                    type: "category",
                    name: "時",
                    data: data.hour_list,
                    splitLine: {
                      show: false,
                    },
                  },
                ],
                yAxis: [
                  {
                    type: "value",
                    name: "件",
                  },
                ],
                series: newSelectedData
              },
            };
            self.loading = false;
          },
          (err) => {
            console.log(err);
          }
        );
      }
    }, 1000);
  },
  data() {
    return {
      timeHour: this.timeHour,
      leftpx: this.leftpx,
      timeLineList: ['178','222','265','309','352','396','439','483','526','569','613','657','701','743','787','830','874','917','961','1004','1048','1091','1135','1178'],
      barShowFlg: true,
      nowDisplayTitle: this.nowDisplayTitle,
      selectedDisplayTitle: this.selectedDisplayTitle,
      loading: this.loading,
      optionNow: this.optionNow,
      optionSelected: this.optionSelected,
      selected_group: this.selected_group,
      group_list: [
        {
          value: "01000",
          label: "01000",
        },
        {
          value: "02000",
          label: "02000",
        }
      ],
      selected_response_type: this.selected_response_type,
      response_type_list: [
        {
          value: "電話応対",
          label: "電話応対",
        },
        {
          value: "チャット応対",
          label: "チャット応対",
        }
      ],
      checkedServiceTime: false,
      datePicker: this.datePicker,
    };
  },

  methods: {
    ShowDetail() {
      if (this.$root.editMode == false) {
        if (this.barShowFlg == true) {
          this.barShowFlg = false;
        } else {
          this.barShowFlg = true;
        }
      }
    },
    loadInitialCharts() {
      this.nowDisplayTitle = "今日のピークマップ・グループ" + this.selected_group.value;
      this.selectedDisplayTitle = this.datePicker + "のピークマップ・グループ" + this.selected_group.value;
      let selectedType;
      if (this.selected_response_type.value == "電話応対") {
        selectedType = "tel";
      } else if (this.selected_response_type.value == "チャット応対") {
        selectedType = "chat";
      }
      let selectedGroup;
      if (this.selected_group.value == "01000") {
        selectedGroup = "01";
      } else if (this.selected_group.value == "02000") {
        selectedGroup = "02";
      }
      let self = this;
      self.loading = true;
      api.getPicMapCount(this.datePicker, selectedGroup, selectedType, this.checkedServiceTime).then(
        (res) => {
          let data = res.data;
          let nowDate = data.output_list['now'];
          let lastYearDate = data.output_list['lastYear'];
          let newData = nowDate.concat(lastYearDate);
          let selectedDate = data.output_list['selected'];
          let selectedLastYearDate = data.output_list['selectedLastYear'];
          let newSelectedData = selectedDate.concat(selectedLastYearDate);
          
          self.optionNow = {
            baseOption: {
              title: {
                right: "10%",
              },
              tooltip: {
                formatter: function (params) {
                    return params.seriesName + "<br />"+ params.marker + params.name +"時 : " + params.value;
                },
              },
              calculable: true,
              barMaxWidth: "50%",
              grid: {
                top: 80,
                bottom: 80,
              },
              xAxis: [
                {
                  type: "category",
                  name: "時",
                  data: data.hour_list,
                  splitLine: {
                    show: false,
                  },
                },
              ],
              yAxis: [
                {
                  type: "value",
                  name: "件",
                },
              ],
              series: newData,
              // series: [{
              //       name: '2022-09-15',
              //       type: 'bar',
              //       stack: '件',
              //       color: '#61a0a8',
              //       data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 0]
              //   }, {
              //       name: '2022-09-15時間帯外',
              //       type: 'bar',
              //       stack: '件',
              //       color: '##B3B3B3',
              //       data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 0]
              //   },{
              //       name: '2022-09-15',
              //       type: 'bar',
              //       stack: '件',
              //       color: '#d48265',
              //       data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 0]
              //   },]
            },
          };

          self.optionSelected = {
            baseOption: {
              title: {
                right: "10%",
              },
              tooltip: {
                formatter: function (params) {
                    return params.seriesName + "<br />"+ params.marker + params.name +"時 : " + params.value;
                },
              },
              calculable: true,
              barMaxWidth: "50%",
              grid: {
                top: 80,
                bottom: 80,
              },
              xAxis: [
                {
                  type: "category",
                  name: "時",
                  data: data.hour_list,
                  splitLine: {
                    show: false,
                  },
                },
              ],
              yAxis: [
                {
                  type: "value",
                  name: "件",
                },
              ],
              series: newSelectedData
            },
          };
          self.loading = false;
        },
        (err) => {
          console.log(err);
        }
      );

    },

    toggleView() {
      this.loadInitialCharts();
    },
    clearClick() {
      this.datePicker = moment().format("YYYY-MM-DD");
      this.selected_group = this.group_list[1];
      this.selected_response_type = this.response_type_list[0];
      this.checkedServiceTime = false;
    },

  },
};
</script>

<style>
.chart-view-picmap {
  height: 46vh !important;
  min-height: 350px;
  max-height: 46vh !important;
}
</style>
